// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__1c7Cr","loader":"style_loader__57Sdx","fullScreen":"style_fullScreen__1HxES","hidden":"style_hidden__19Fj2"};